/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.0.0
 */
import styled from 'styled-components';

import { colors, fonts } from '../../../../../theme';
import { FlexMiddleStyled, FlexStyled } from '../../../../common/Block/Flexbox';
import { LayoutStyled } from '../../../../common/Block/Layout';

export const FooterModalStyled = styled.div`
    max-width: 600px;
    padding: 56px;
    box-sizing: border-box;

    &.prepayment-invoice {
       padding: 24px 0;
    }
`;

export const FooterModalImageStyled = styled.div`
    > div {
        margin: 0 auto 32px;
    }
`;

export const FooterModalTitleStyled = styled(LayoutStyled)`
    ${fonts.textHeader3};

    &.prepayment-invoice__title {
        box-sizing: border-box;
        padding: 0 24px 24px;
    }
`;

export const FooterModalTextStyled = styled(LayoutStyled)`
    &.mobile-cash-modal__text{
        margin-bottom: 24px;
    }
    &.inquiry-created-modal__text {
        display: flex;
        flex-direction: column;
        & span:first-child {
            margin-bottom: 24px;
        }
    }
    &.prepayment-invoice__body {
       padding: 24px;
       margin-bottom: 24px;
       background-color: ${colors.backgroundColorModal};
    }
`;
export const FooterModalFooterStyled = styled(FlexStyled)`
    width: 100%;
    box-sizing: border-box;

    &.prepayment-invoice__buttons {
        padding: 0 24px;
    }
`;

export const FooterModalFooterCloseStyled = styled(FlexMiddleStyled)`
    margin-left: 16px;
    cursor: pointer;
`;
